import React from 'react';
import PropTypes from 'prop-types';
import ReactLoading from 'react-loading';
import { Row, Col } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { Toast } from '../alerts';
import { Select } from '../fields';
import { LoadingButton } from '../buttons';
import { EmployeeService } from '../../services';
import { EntityError } from '../../utils';

import '../../styles/cards/venue.css';

class VenueCard extends React.Component {
  constructor(props) {
    super(props);

    const { employee } = this.props;

    this.state = {
      loading: false,
      saving: false,
      employee: employee,
      venue: null,
      invalidPost: {
        new_venue_id: false,
        duplicate_venue: false,
      },
    };

    this.onSaveBtnClick = this.onSaveBtnClick.bind(this);

    this.employeeService = new EmployeeService();
  }

  async onSaveBtnClick() {
    const { employee, venue, invalidPost } = this.state;
    const { t, history } = this.props;

    this.setState({ saving: true, invalidPost: EntityError.setInputErrors(invalidPost, null, true) });

    const newVenueId = venue ? venue._id : null;
    const result = await this.employeeService.updateVenue(employee.venue._id, employee.user._id, newVenueId);

    if (result && result.success) {
      const employeeResult = await this.employeeService.getbyid(newVenueId, employee.user._id);

      if (employeeResult && employeeResult.success) {
        // UPDATE HISTORY
        history.replace({
          pathname: '/employees/detail',
          state: { employee: employeeResult.employee },
        });

        this.setState({ employee: employeeResult.employee });

        Toast.success(t('Updated'));
      }
    } else if (result && result.ecode === 409) {
      this.setState({
        invalidPost: {
          ...this.state.invalidPost,
          duplicate_venue: true,
        },
      });
    } else if (result && result.ecode === 422) {
      this.setState({
        invalidPost: EntityError.setInputErrors(invalidPost, result.errors),
      });
    }

    this.setState({ saving: false });
  }

  render() {
    const { loading, saving, employee, venue, invalidPost } = this.state;
    const { t } = this.props;

    return (
      <div className='venuecard-container'>
        {loading ? (
          <div className='margin-auto'>
            <ReactLoading type='spin' color='#000' height='24px' width='24px' />
          </div>
        ) : (
          <div>
            <Row>
              <Col md={12}>
                <p className='venuecard-field'>
                  {t('Current Venue')}: <span>{employee.venue.name}</span>
                </p>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Select
                  fullWidth
                  type='venues'
                  field='name'
                  label={t('New Venue')}
                  error={invalidPost.new_venue_id}
                  errorText={t('Venue is required')}
                  value={venue}
                  defaultValue={venue}
                  onChange={(venue) => this.setState({ venue: venue })}
                ></Select>
              </Col>
            </Row>
            <Row>
              <Col md={12} className='text-right'>
                <LoadingButton text={t('Save')} state={saving ? 'LOADING' : 'DONE'} onClick={this.onSaveBtnClick} />
              </Col>
            </Row>

            {invalidPost.duplicate_venue && <span className='venuecard-error-text'>{t('The user already has permission to this venue.')}</span>}
          </div>
        )}
      </div>
    );
  }
}

VenueCard.propTypes = {
  employee: PropTypes.object,
  onChange: PropTypes.oneOfType([PropTypes.func, PropTypes.any]),
  onSaveBtnClick: PropTypes.oneOfType([PropTypes.func, PropTypes.any]),
};

VenueCard.defaultProps = {
  onChange: Function.prototype,
  onSaveBtnClick: Function.prototype,
};

export default withTranslation()(withRouter(VenueCard));
